/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SequenceAlign } from './SequenceAlign';
import {
    SequenceAlignFromJSON,
    SequenceAlignFromJSONTyped,
    SequenceAlignToJSON,
} from './SequenceAlign';

/**
 * 
 * @export
 * @interface SimilarityTreeRequest
 */
export interface SimilarityTreeRequest {
    /**
     * 
     * @type {Array<SequenceAlign>}
     * @memberof SimilarityTreeRequest
     */
    sequences: Array<SequenceAlign>;
}

/**
 * Check if a given object implements the SimilarityTreeRequest interface.
 */
export function instanceOfSimilarityTreeRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sequences" in value;

    return isInstance;
}

export function SimilarityTreeRequestFromJSON(json: any): SimilarityTreeRequest {
    return SimilarityTreeRequestFromJSONTyped(json, false);
}

export function SimilarityTreeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarityTreeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sequences': ((json['sequences'] as Array<any>).map(SequenceAlignFromJSON)),
    };
}

export function SimilarityTreeRequestToJSON(value?: SimilarityTreeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sequences': ((value.sequences as Array<any>).map(SequenceAlignToJSON)),
    };
}

